import axios from 'axios';

/**
 * Cliente HTTP del backend del traductor (kiTranslate-Backend).
 */
const translateClient = axios.create({
  baseURL: import.meta.env.VITE_TRANSLATE_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export default translateClient;
